var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { transformMillisecondsToStringDuration } from "../../utils/time";
export default (function (props) {
    return _jsx("span", __assign({ style: { fontVariant: 'tabular-nums' } }, { children: transformMillisecondsToStringDuration(props.time) }));
});
//# sourceMappingURL=index.js.map